export const SECTOR_CONTENT = {
  "care-homes": {
    eyebrow: "Care Home Contracts · UK",
    lines: ["Dining with", "dignity,", "every day."],
    italic: 1,
    intro:
      "Freshly cooked, resident-led menus for residential and nursing homes. We run the kitchen so your team can focus on care.",
    image: "/images/care_dining.jpg",
    detail: "/images/chef_herb_plating.jpg",
    highlights: [
      { t: "Texture-modified menus", d: "Meals prepared to each resident's texture and diet plan, so everyone eats safely and well." },
      { t: "Hydration & snacks", d: "Planned snack and drinks rounds that keep residents nourished between meals." },
      { t: "Resident-led choices", d: "Tasting sessions and feedback loops so menus reflect the people you care for." },
      { t: "Records, kept", d: "Allergen, dietary and food safety records organised and ready when you need them." },
    ],
  },
  schools: {
    eyebrow: "School Catering Contracts · UK",
    lines: ["Lunches", "they actually", "finish."],
    italic: 1,
    intro:
      "Nutritious, colourful school meals that pupils look forward to, from breakfast club to the final bell.",
    image: "/images/school_lunch.jpg",
    detail: "/images/chef_team_service.jpg",
    highlights: [
      { t: "Balanced menus", d: "Rotating menus planned around school food standards and seasonal produce." },
      { t: "Allergen-managed", d: "Clear labelling and careful handling for every pupil's dietary needs." },
      { t: "Breakfast & clubs", d: "Morning, after-school and holiday club catering under one contract." },
      { t: "Pupil voice", d: "Feedback panels and themed days that keep the dining hall busy." },
    ],
  },
  corporate: {
    eyebrow: "Corporate Catering Contracts · UK",
    lines: ["Workplace", "dining,", "elevated."],
    italic: 2,
    intro:
      "From daily staff restaurants to boardroom lunches and client events, food that makes the office worth the commute.",
    image: "/images/banquet_table_buffet.jpg",
    detail: "/images/corporate_modern_table.jpg",
    highlights: [
      { t: "Staff restaurants", d: "Daily hot counters, salad bars and grab-and-go built around your team." },
      { t: "Meetings & boardrooms", d: "Reliable meeting catering, delivered on time and beautifully set." },
      { t: "Client hospitality", d: "Events and receptions that reflect your brand at its best." },
      { t: "Flexible scale", d: "Plans that grow with your headcount and hybrid working patterns." },
    ],
  },
};

export const SECTOR_LINKS = [
  { slug: "care-homes", label: "Care Homes" },
  { slug: "schools", label: "Schools" },
  { slug: "corporate", label: "Corporate" },
];
